export const LAST_CONTEXT_KEY = 'edgentik:lastNavContext:v1';

export type NavContext = {
  device_id?: string;
  camera_id?: string;
  incident_id?: string;
  site_id?: string;
};

export function readNavContext(): NavContext {
  try {
    const raw = localStorage.getItem(LAST_CONTEXT_KEY);
    if (!raw) return {};
    const value = JSON.parse(raw);
    if (!value || typeof value !== 'object') return {};
    const next: NavContext = {};
    if (typeof value.device_id === 'string' && value.device_id) next.device_id = value.device_id;
    if (typeof value.camera_id === 'string' && value.camera_id) next.camera_id = value.camera_id;
    if (typeof value.incident_id === 'string' && value.incident_id) next.incident_id = value.incident_id;
    if (typeof value.site_id === 'string' && value.site_id) next.site_id = value.site_id;
    return next;
  } catch {
    return {};
  }
}

export function writeNavContext(ctx: NavContext) {
  try {
    localStorage.setItem(LAST_CONTEXT_KEY, JSON.stringify(ctx || {}));
  } catch {
    // ignore storage failures
  }
}

export function mergeNavContext(a: NavContext, b: NavContext): NavContext {
  return {
    device_id: b.device_id || a.device_id,
    camera_id: b.camera_id || a.camera_id,
    incident_id: b.incident_id || a.incident_id,
    site_id: b.site_id || a.site_id,
  };
}
